import { render } from "./error405Page.vue?vue&type=template&id=c7c710aa&scoped=true"
const script = {}

import "./error405Page.vue?vue&type=style&index=0&id=c7c710aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c710aa"]])

export default __exports__